<template>
  <div class="team">
    <div class="team__role">
      <p data-testid="owner-role" class="team__role-title">
        {{ $t('common.roles.author') }}
      </p>
      <template>
        <TeamMember
          :avatarMediaObject="owner.avatarMediaObject"
          :name="owner.name"
          :lastName="owner.lastName"
          :email="owner.email"
          :solvedRev="owner.solvedRev"
        />
      </template>
    </div>
    <div class="team__role" v-if="coach.name || coach.lastName || coach.email">
      <p data-testid="coach-role" class="team__role-title">
        {{ $t('common.roles.coach_one') }}
      </p>
      <template>
        <TeamMember
          :avatarMediaObject="coach.avatarMediaObject"
          :name="coach.name"
          :lastName="coach.lastName"
          :email="coach.email"
          :solvedRev="coach.solvedRev"
        />
      </template>
    </div>
    <div class="team__role">
      <p
        data-testid="member-role"
        class="team__role-title"
        v-if="members.length"
      >
        {{ $t('common.collaborator_other') }}
      </p>
      <div class="team__collaborators">
        <template v-for="(member, index) in members">
          <TeamMember
            :key="index"
            :avatarMediaObject="member.avatarMediaObject"
            :name="member.name"
            :lastName="member.lastName"
            :email="member.email"
            :solvedRev="member.solvedRev"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TeamMember from './TeamMember.vue'

export default {
  name: 'PrintTeam',

  components: {
    TeamMember,
  },

  props: {
    owner: {
      type: Object,
      required: true,
    },
    coach: {
      type: Object,
      required: true,
    },
    members: {
      type: Array,
      required: false,
    },
  },
}
</script>
<style lang="scss" scoped>
@media screen, print {
  .team {
    display: flex;
    height: 100%;
    width: 100%;
    &__role {
      flex: 1;
      &:last-child {
        flex-grow: 4;
      }
      &-title {
        font-size: 10px;
        font-weight: bold;
        color: $color-blue-darken2;
      }
    }
    &__collaborators {
      display: flex;
      justify-content: space-evenly;
    }
  }
}
</style>
